export default {
  loginWelcome: `You have succesfully logged in. Thank You.` 
}


// WEBPACK FOOTER //
// ./src/static/notifications/index.js